/**
 * WebMCP Actions Store
 *
 * Promise-based signal store for triggering UI actions (open dialogs, etc.)
 * from WebMCP tools. Components watch these signals, open the appropriate
 * dialog with the pre-filled name, save the entity, then resolve/reject.
 *
 * Flow:
 *   1. Tool navigates to the correct tab
 *   2. Tool sets e.g. pendingCreateRole = { name, resolve, reject }
 *   3. Component watcher fires → opens dialog with prefilled name → auto-saves
 *   4. Component calls signal.resolve(result) or signal.reject(error)
 *   5. Tool's await gets the result and returns it to the agent
 */
import { defineStore } from "pinia";
import { ref } from "vue";

export const useWebMcpActionsStore = defineStore("webmcpActions", () => {
  /** @type {import('vue').Ref<{ name: string, resolve: Function, reject: Function } | null>} */
  const pendingCreateRole = ref(null);

  /** @type {import('vue').Ref<{ name: string, resolve: Function, reject: Function } | null>} */
  const pendingCreateResponsibility = ref(null);

  return { pendingCreateRole, pendingCreateResponsibility };
});
